import React, { useState, useEffect } from "react";

export default function DeviceChart(props) {
  return "device chart!!!!";
}
